<template>
  <b-modal
    id="modal-celebration-download"
    :visible="visible"
    title="Download Birthdays &amp; Anniversaries"
    size="sm"
    ok-title="Download CSV"
    cancel-title="Cancel"
    ok-variant="success"
    :ok-disabled="!celebrationDownloadFrom || !celebrationDownloadTo"
    @ok="$emit('ok')"
    @hidden="$emit('update:visible', false)"
  >
    <p class="text-muted mb-3" style="font-size: 0.88rem;">
      Select the date range to include birthdays and work anniversaries in the export.
    </p>

    <div class="d-flex flex-wrap mb-3" style="gap: 6px;">
      <b-button
        v-for="preset in celebrationPresets"
        :key="preset.value"
        size="sm"
        :variant="celebrationActivePreset === preset.value ? 'primary' : 'outline-secondary'"
        :class="celebrationActivePreset === preset.value ? 'font-weight-bold' : ''"
        @click.stop="$emit('set-range', preset.value)"
      >
        <feather-icon v-if="celebrationActivePreset === preset.value" icon="CheckIcon" size="12" class="mr-25" />
        {{ preset.label }}
      </b-button>
    </div>

    <b-form-group label="From" label-class="font-weight-bold small">
      <b-form-input
        :value="celebrationDownloadFrom"
        type="date"
        size="sm"
        :max="celebrationDownloadTo || ''"
        @change="$emit('update:celebrationDownloadFrom', $event); $emit('clear-preset')"
      />
    </b-form-group>

    <b-form-group label="To" label-class="font-weight-bold small" class="mb-0">
      <b-form-input
        :value="celebrationDownloadTo"
        type="date"
        size="sm"
        :min="celebrationDownloadFrom || ''"
        @change="$emit('update:celebrationDownloadTo', $event); $emit('clear-preset')"
      />
    </b-form-group>

    <p
      v-if="celebrationDownloadFrom && celebrationDownloadTo"
      class="text-primary mt-2 mb-0"
      style="font-size: 0.82rem;"
    >
      <feather-icon icon="CalendarIcon" size="12" class="mr-1" />
      {{ celebrationRangeSummary }}
    </p>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'

export default {
  name: 'CelebrationDownloadModal',
  components: {
    BModal, BFormGroup, BFormInput, BButton,
  },
  props: {
    visible: { type: Boolean, default: false },
    celebrationDownloadFrom: { type: String, default: '' },
    celebrationDownloadTo: { type: String, default: '' },
    celebrationActivePreset: { type: String, default: null },
    celebrationPresets: { type: Array, default: () => [] },
    celebrationRangeSummary: { type: String, default: '' },
  },
}
</script>
